import { render, staticRenderFns } from "./EditionBadge.vue?vue&type=template&id=b35f9d04&scoped=true&"
import script from "./EditionBadge.vue?vue&type=script&lang=js&"
export * from "./EditionBadge.vue?vue&type=script&lang=js&"
import style0 from "./EditionBadge.vue?vue&type=style&index=0&id=b35f9d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35f9d04",
  null
  
)

export default component.exports